import styled from "styled-components";

export const MissionsContentWrapper = styled.div`
  width: 100%;
  padding: 1rem;
`;

export const MissionCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(calc((100% - 2rem) / 3), 1fr)
  );
  gap: 1rem;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(
      auto-fill,
      minmax(calc((100% - 1rem) / 2), 1fr)
    );
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export const MissionCard = styled.div`
  /* flex: 1; */
  height: 100%;
  min-width: 350px; /* Added minimum width to prevent cards from being too skinny */
  /* Max-width for 3 columns on large screens (gap is 1rem, so 2rem total for 3 items) */
  /* max-width: calc((100% - 2rem) / 3); */
  /* background-color: ${({ theme }) => theme.background};
  border: 2px solid ${({ theme }) => theme.borderDark};
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  position: relative; */

  overflow: hidden;

  /* Medium screens: 2 columns (gap is 1rem) */
  @media (max-width: 1024px) {
    max-width: calc((100% - 1rem) / 2);
  }

  /* Small screens (mobile): 1 column */
  @media (max-width: ${({ theme }) => theme.mobile}) {
    max-width: 100%;
    min-width: 100%; /* Override min-width for mobile to ensure full width */
  }

  ${({ $scanning }) =>
    $scanning &&
    `
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg,
        transparent 0%,
        rgba(0, 255, 0, 0.1) 50%,
        transparent 100%);
      animation: scan 2s linear infinite;
      pointer-events: none;
      z-index: 1;
    }
    
    @keyframes scan {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  `}
`;

export const MissionRedactedBackground = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
`;

export const MissionRedacted = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  color: #cdcdcd;
  font-family: "NeueMachina";
  text-transform: uppercase;
  font-weight: 800;
  text-shadow: 1px 1px 5px ${({theme}) => theme.background};
`;

export const MissionCardHeader = styled.div`
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: ${({ $color, theme }) => $color || theme.baseRed};
  color: ${({theme }) => theme.background};
  font-family: "NeueMachina";
  text-transform: uppercase;
  font-size: 1.5rem;
  letter-spacing: -0.07em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: first baseline;
  gap: 0.5rem;
`;

export const MissionCardDescription = styled.div`
  /* padding: 1rem 1.5rem; */
  width: 100%;
  color: white;
  font-size: 1.75rem;
  line-height: 1;
  font-family: "NeueMachina";
  text-transform: uppercase;
  letter-spacing: -0.07em;
  font-weight: 500;

  @media (max-width: 1400px) {
    font-size: 1.5rem;
  }

  @media (max-width: 1024px) {
    width: 100%;;
  }
`;

export const MissionCardImagesContainer = styled.div`
  width: 40%;
  aspect-ratio: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  position: relative;

  @media (max-width: 1024px) {
    width: 60%;;
  }


  img:nth-child(1) {
    height: 60%;
    right: 0;
    top: 15%;
  }
  img:nth-child(2) {
    height: 80%;
    top: 0%;
    left: 0
  }

  img:nth-child(3) {  
    height: 50%;
    bottom: 5%;
  }
`;

export const MissionCardImage = styled.img`
  height: 75%;
  width: auto;
  object-fit: contain;
  position: absolute;
`;

export const MissionCardFlexRow = styled.div`
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 1rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;


export const MissionCardTasksContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem 1.5rem;
  gap: 1rem; // Reduced gap to make tasks more crowded together
`;

export const MissionCardTask = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 0.5rem;
  color: white;
  font-size: 1rem;
  font-family: "NeueMachina";
  padding: 0.5rem; // Add some padding so outline isn't too close to content
  margin: -0.5rem; // Negative margin to counteract padding for layout
  outline: 2px solid transparent; // Base for smooth transition
  background-color: transparent; // Explicitly set base background
  transition:
    outline 0.2s ease-in-out,
    background-color 0.2s ease-in-out; // Added background-color to transition
  cursor: ${({ $interactive }) => ($interactive ? "pointer" : "default")};

  ${({ $interactive, theme }) =>
    $interactive &&
    `
    &:hover {
      outline: 5px solid ${theme.selection};
      background-color: #3626F4; // Added hover background color
    }
  `}
`;

export const MissionCardTaskCheckbox = styled.div`
  min-width: 4rem; // Increased from 2rem
  height: auto;
  aspect-ratio: 3 / 2; // Maintains a 3:2 aspect ratio
  border: 6px solid
    ${({ $checked, theme }) => ($checked ? theme.baseGreen : theme.baseRed)};
  color: white;
  display: flex;
  background-color: transparent;
  box-sizing: border-box;
  flex-shrink: 0;
  position: relative;

  ${({ $checked, theme }) =>
    $checked &&
    `
    &:after {
      content: "";
      background-color: ${theme.baseGreen};
      position: absolute;
      width: 100%;
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
      mask: url('/assets/skull.svg');
      mask-size: 90%;
      mask-position: center;
    }
  `}
`;

export const MissionCardTaskContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  flex-grow: 1;
  font-family: "NeueMachina";
`;

export const MissionCardTaskText = styled.span`
  text-decoration: none; // Removed line-through for completed tasks
  color: ${({ $completed, theme }) =>
    $completed
      ? theme.baseGreen
      : theme.baseRed}; // Green for completed, red for incomplete
  line-height: 1; // Tighter line height
  text-transform: uppercase;
  letter-spacing: normal; // Normal letter spacing as requested
  font-size: 2.5rem; // Increased size
  font-weight: 500; // Added slightly bolder font weight
  font-family: "BebasNeue"; // Changed to BebasNeue font
`;

export const MissionCardTaskReward = styled.span`
  color: white; // Changed from yellow to white
  font-weight: normal; // Changed from bold to normal
  text-transform: uppercase;
  letter-spacing: -0.07em;
  font-size: 0.85rem; // Reduced size
  font-family: "NeueMachina"; // Explicitly set to NeueMachina
  animation: fadeIn 0.5s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const MissionCardTaskColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MissionCardTaskButton = styled.button`
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.baseRedHover || "#a83232" : theme.baseRed};
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-family: "NeueMachina";
  font-weight: bold;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  min-width: fit-content;
  flex-shrink: 0;
  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};

  &:hover {
    background-color: ${({ theme, disabled }) =>
      disabled
        ? theme.baseRedHover || "#a83232"
        : theme.baseRedHover || theme.baseRed};
    transform: ${({ disabled }) => (disabled ? "none" : "scale(1.05)")};
  }

  .spinner {
    display: inline-block;
    margin-left: 5px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const MissionCardFooter = styled.div`
  width: 100%;
  padding: 0 1.5rem 1rem;
  color: white;
  font-size: 0.9rem;
  font-style: italic;
  font-family: "NeueMachina";
  margin-top: auto;
`;

export const EncryptedText = styled.div`
  font-family: monospace;
  color: ${({ theme }) => theme.baseGreen};
  letter-spacing: 1px;
  overflow: hidden;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(0, 255, 0, 0.1) 50%,
      transparent 100%
    );
    animation: scan 2s linear infinite;
  }

  @keyframes scan {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

export const EncryptedDescription = styled(MissionCardDescription)`
  font-family: monospace;
  letter-spacing: 0.5rem;
  font-size: 1.3rem;
  padding: 1rem;
  line-break: anywhere;
`;

export const MissionCardTaskHint = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) =>
    theme.textMuted || "#aaa"}; // Assuming a theme variable or fallback
  font-style: italic;
  margin-top: 0.25rem;
  font-family: "NeueMachina";
`;
